/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./WhyChooseUs.css";

// IMPORT ICONS
import Icon1 from "../Image/HOME/whyicon1.png";
import Icon2 from "../Image/HOME/whyicon2.png";
import Icon3 from "../Image/HOME/whyicon3.png";
import Icon4 from "../Image/HOME/whyicon4.png";
import Icon5 from "../Image/HOME/whyicon5.png";
import Icon6 from "../Image/HOME/whyicon6.png";

const services = [
  { icon: Icon1, title: "Rapid Multi-City Growth", desc: "Our Dedicated Work Over The Past Many Years Has Led To Rapid Growth And Presence In More Than 15 + Cities Across India And Growing." },
  { icon: Icon2, title: "GST Department Award Winner", desc: "Awarded By The GST Department For 3 Consecutive Years For Timely & Significant Contribution" },
  { icon: Icon3, title: "Full Statutory Compliance", desc: "Strict ESI, PF, Minimum-Wage & Labour Law Compliance" },
  { icon: Icon4, title: "Customised Service Modules", desc: "For Corporates, Industrial Plants, Residential Societies, Retail & Warehouses" },
  { icon: Icon5, title: "Scalable Manpower", desc: "Supported By Supervisors, Audits And Tech-Enabled Monitoring" },
  { icon: Icon6, title: "24/7 Operational Capability", desc: "Round-The-Clock Service Delivery Across All Locations" },
];
export default function WhyChooseUs() {
  return (
    <section className="services-section">
      {/* HEADER */}
      <div className="services-header">
        <div className="services-tag">Our Advantages</div>
        <div className="ChooseUstext">
        <h2>Why Densat</h2>
        <p>We prioritize excellence in every aspect of our service delivery</p>
        </div>
      </div>

      {/* SERVICES GRID */}
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">
              <img src={service.icon} alt={service.title} />
            </div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          
          </div>
        ))}
      </div>
    </section>
  );
}
